// extracted by mini-css-extract-plugin
export var accordion = "_bd-0";
export var chevron = "_bd-3";
export var closed = "_bd-2";
export var content = "_bd-4";
export var open = "_bd-1";
export var rotate = "_bd-5";